import { requestApi } from './helper';

export const DEVIATION_LIST = 'DEVIATION_LIST';

export const DeviationList = (deviationList) => (
  { type: DEVIATION_LIST, deviationList }
);
export const requestDeviationList = () => requestApi('/destinations?servicesites=true&deviation=true&ordered=true&endcustomer=undefined&source=webui', null, DeviationList);



// WEBPACK FOOTER //
// ./src/actions/deviations.js